export const SEARCH_PARAMS_TO_OMIT_FOR_SEARCHES = [
  'layout',
  'redirectId',
  'closeSearchBox',
  'offerFilters',
  'roomFilters',
  'roomUserSearch',
  'srpSearchId'
]

// Added as a part of 7d6464d8-move-auth-to-ap
export enum OfferAccessFlow {
  PrivateLockedDeal = 'privateLockedDeal',
  AppLocked = 'appLocked',
  SMSConfirmation = 'smsConfirmation',
  RegularDeal = 'regularDeal'
}

export type BaseOfferAccessFlowSettings = {
  // if the offer is locked
  isLocked: boolean
  // which type of auth flow does offer require
  flowType?: OfferAccessFlow
}
export type OfferAccessFlowSettings = {
  // which type of auth flow does offer require
  flowType: OfferAccessFlow
  // if the offer is locked
  isLocked: boolean
  // if offer is special (app locked, private locked deal, sms confirmation)
  isSpecial: boolean
  // if offer is special but unlocked
  isSpecialUnlocked: boolean
  // if access flow requires auth
  isAuthRequired: boolean
  // if access flow requires sms
  isSMSRequired: boolean
  // if access flow requires app
  isAppRequired: boolean
  // if access flow is locked
  isAuthLocked: boolean
  // if access flow is locked
  isSMSLocked: boolean
  // if access flow is locked
  isAppLocked: boolean
  // if access flow requires auth but is unlocked
  isAuthRequiredUnlocked: boolean
  // if access flow requires sms but is unlocked
  isSMSRequiredUnlocked: boolean
  // if access flow requires app but is unlocked
  isAppRequiredUnlocked: boolean
  // if access flow is locked for auth or sms, generally used for displaying lock icon
  isAuthOrSMSLocked: boolean
}
// END added as part of 7d6464d8-move-auth-to-ap
